<pw-view-title>
  {{'change.documents.documents' | translate}} {{(snr | async)?.NAME}}
</pw-view-title>

<pw-view-actions>
  <button mat-button routerLink="/pm-constructions/{{route.snapshot.params.constructionId}}/pm-indices/{{route.snapshot.params.indexId}}/prisma/import">
    DOKUMENTE IMPORTIEREN
  </button>
</pw-view-actions>
<div class="ps-grid-3-col">
  <mat-card *ngFor="let doc of documents | async">
    <mat-card-header>
      <img mat-card-avatar src="{{doc.ICON_URL}}"/>
      <mat-card-title>{{doc.NAME}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="ps-grid-2-col">
        <div>ZI: {{doc.INDEX_ZI}}</div>
        <div>AI: {{doc.INDEX_AI}}</div>
        <div>Beschreibung: {{doc.DESCRIPTION}}</div>
        <div>Typ: {{doc.DOKU_TYP}}</div>
        <div>Format: {{doc.DOKU_FORMAT}}</div>
        <div>Reife: {{doc.DOKU_REIFE}}</div>
        <mat-divider style="grid-column: auto / span 2"></mat-divider>
        <div>Ersteller: {{doc.CREATOR_NAME}} {{doc.DATUMERSTELLUNG | date: 'short'}}</div>
        <div>geändert: {{doc.CHANGE_NAME}} {{doc.DATUMAEND | date: 'short'}}</div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="deleteDocument(doc)">LÖSCHEN</button>
    </mat-card-actions>
  </mat-card>
</div>
